import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').Notification} Notification
 */

/**
 * @param {State} state
 * @param {import('rxjs').Subscription} obj
 */
export function setNotificationsSub (state, obj) {
  if (state.notificationsSub) state.notificationsSub.unsubscribe();
  state.notificationsSub = obj;
  // reset store
  if (!state.notificationsSub) {
    state.notifications = [];
    state.notificationsNew = [];
  }
}

/**
 * @param {State} state
 */
export function clearNotificationsNew (state) {
  state.notificationsNew = [];
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {boolean} [obj.addToNewNotifications]
 * @param {Notification} obj.item
 */
export function updateInNotifications (state, obj) {
  const { item, upsert, addToNewNotifications } = obj;
  const list = state.appointments;
  // find existing
  const index = list.findIndex(i => i.id === item.id);

  // update existing (inherit patient details)
  if (~index) {
    // not a valid change, discard
    if (!item.seen) return;
    // marked as seen
    return Vue.set(list, index, item);
  }

  // add to list
  if (upsert) {
    list.push(item);

    // sort ascending
    list.sort((a, b) => b.createdAt - a.createdAt);

    // add to new notifs list (if needed)
    if (!item.seen && addToNewNotifications) {
      const list = state.notificationsNew;
      const index = list.findIndex(n => n.id === item.id);
      if (!~index) list.push(item);
    }
  }
}
